/**
 * An empty state inside a card (TMMAPP-0088, pattern 9; visual contract §6, TMMAPP-0099): padding
 * 26 20, the copy `body2` in `text2`, wrapping within 520px. The action, when there is one, is
 * the caller's button.
 */
import type { ReactNode } from 'react';
import { Box, Paper } from '@mui/material';

interface EmptyCardProps {
  children: ReactNode;
  action?: ReactNode;
}

export function EmptyCard({ children, action }: EmptyCardProps) {
  return (
    <Paper sx={{ p: '26px 20px' }}>
      <Box sx={{ maxWidth: 520, color: 'text.secondary', typography: 'body2' }}>{children}</Box>
      {action !== undefined && action !== null && <Box sx={{ mt: 1.5 }}>{action}</Box>}
    </Paper>
  );
}
